import { parseFullSymbol } from "./helpers.js";
import { resolveMarketId, shahooMarketToDenaId } from "@lib/ranger/helpers";
import { getMarketsCatalogSnapshot } from "@core/utils/marketsCatalogStore";

const channelToSubscription = new Map();

/** Lazily resolve ranger subscribeKline from window to avoid circular imports. */
function getRangerSubscribe() {
  return window.__shahooRangerSubscribeKline;
}

export function setRangerKlineSubscribe(fn) {
  window.__shahooRangerSubscribeKline = fn;
}

function resolutionToMinutes(resolution) {
  if (resolution === "1D" || resolution === "D" || resolution === "d") return 1440;
  if (resolution === "1W" || resolution === "W") return 10080;
  const n = parseInt(resolution, 10);
  return Number.isFinite(n) ? n : 240;
}

function resolveTvMarketId(fromSymbol, toSymbol) {
  const route = `${fromSymbol}-${toSymbol}`;
  const snap = getMarketsCatalogSnapshot();
  const getByRoute = (r) =>
    (snap?.markets || []).find((m) => m.route === r) || null;
  return (
    resolveMarketId(route, getByRoute) ||
    shahooMarketToDenaId(`${fromSymbol}_${toSymbol}`)
  );
}

export function subscribeOnStream(
  symbolInfo,
  resolution,
  onRealtimeCallback,
  subscribeUID,
  onResetCacheNeededCallback,
  lastDailyBar
) {
  const parsed = parseFullSymbol(symbolInfo.full_name);
  if (!parsed) return;

  const marketId = resolveTvMarketId(parsed.fromSymbol, parsed.toSymbol);
  const minutes = resolutionToMinutes(resolution);
  const channelString = `${marketId}|${minutes}`;

  const handler = {
    id: subscribeUID,
    callback: onRealtimeCallback,
  };

  let subscriptionItem = channelToSubscription.get(channelString);
  if (subscriptionItem) {
    subscriptionItem.handlers.push(handler);
    return;
  }

  const subscribeKline = getRangerSubscribe();
  let unsubscribe = () => {};
  if (typeof subscribeKline === "function" && marketId) {
    unsubscribe = subscribeKline(marketId, minutes, (bar) => {
      const item = channelToSubscription.get(channelString);
      if (!item) return;
      item.lastDailyBar = bar;
      item.handlers.forEach((h) => h.callback(bar));
    });
  }

  subscriptionItem = {
    subscribeUID,
    resolution,
    lastDailyBar,
    handlers: [handler],
    unsubscribe,
  };
  channelToSubscription.set(channelString, subscriptionItem);
}

export function unsubscribeFromStream(subscriberUID) {
  for (const channelString of channelToSubscription.keys()) {
    const subscriptionItem = channelToSubscription.get(channelString);
    const handlerIndex = subscriptionItem.handlers.findIndex(
      (handler) => handler.id === subscriberUID
    );

    if (handlerIndex !== -1) {
      subscriptionItem.handlers.splice(handlerIndex, 1);

      if (subscriptionItem.handlers.length === 0) {
        if (typeof subscriptionItem.unsubscribe === "function") {
          subscriptionItem.unsubscribe();
        }
        channelToSubscription.delete(channelString);
        break;
      }
    }
  }
}
